import api from '../../api';
// 获取领导列表
export function getLeadList(params) {
  return api.post('/lead/getLeadList.go', params, false, false).then(res => res);
}
// 新增领导
export function addLead(params) {
  return api.post('/lead/addLead.go', params, false, false).then(res => res);
}
// 删除领导
export function delLead(params) {
  return api.post('/lead/delLead.go', params, false, false).then(res => res);
}
// 更新领导
export function upLead(params) {
  return api.post('/lead/upLead.go', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/adminApi/zh/leader.js